
import { useState } from 'react';
import { useToast } from "@/hooks/use-toast";
import { useSitemapVerification } from './sitemap/useSitemapVerification';

export const useSitemapGeneration = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const { 
    isVerifying, 
    verificationDetails,
    verifySitemapAccess 
  } = useSitemapVerification();
  const { toast } = useToast();

  const generateSitemap = async () => {
    try {
      setIsGenerating(true);
      
      toast({
        title: "Generating Sitemap",
        description: "This may take a moment...",
        variant: "default",
      });
      
      console.log('Refreshing sitemap via dynamic endpoint...');
      const response = await fetch(`/sitemap.xml?t=${Date.now()}`);

      if (!response.ok) {
        throw new Error('Failed to fetch sitemap');
      }

      toast({
        title: "Sitemap Refreshed",
        description: `Checked at ${new Date().toLocaleTimeString()}.`,
        variant: "default",
      });

      setTimeout(() => verifySitemapAccess(), 500);
      return { success: true };
    } catch (error) {
      console.error("Error generating sitemap:", error);
      
      toast({
        title: "Error",
        description: `Failed to generate sitemap: ${error instanceof Error ? error.message : String(error)}`,
        variant: "destructive",
      });
      throw error;
    } finally {
      setIsGenerating(false);
    }
  };

  return {
    isGenerating,
    isVerifying,
    verificationDetails,
    generateSitemap
  };
};
